<div class="container-fluid">
  <div class="row">
    <div class="col-12 px-0">
      <div class="card p-0 border-0 animate-fade-in shadow-none">
        <div class="card-body p-3">
          <!-- Header Section -->
          <div class="d-flex flex-row flex-wrap justify-content-between align-items-start mb-4 gap-3">
            <div>
              <h1 class="card-title mb-1">Visits</h1>
              <span class="sub-text">Select an employee to view their party visit records</span>
            </div>
          </div>

          <!-- Export Dealer Visits -->
          <div class="card bg-light p-3 mb-4">
            <div class="d-flex align-items-center gap-2 mb-2">
              <span class="fw-semibold small">Export Dealer Visits</span>
            </div>
            <div class="row">
              <!-- Year -->
              <div class="col-6 col-lg-2 ps-0">
                <input
                  type="number"
                  class="form-control form-control-sm"
                  [(ngModel)]="exportFilters.year"
                  [min]="2020"
                  [max]="2100"
                  placeholder="Year" />
              </div>

              <!-- Month -->
              <div class="col-6 col-lg-2">
                <ng-select
                  placeholder="All months"
                  [items]="monthOptions"
                  [(ngModel)]="exportFilters.month"
                  bindValue="value"
                  bindLabel="label"
                  [clearable]="true"
                  [searchable]="false" />
              </div>

              <!-- Specific Date -->
              <div class="col-6 col-lg-2">
                <input
                  type="date"
                  class="form-control form-control-sm"
                  [(ngModel)]="exportFilters.date"
                  title="Filter by specific date (overrides month)" />
              </div>

              <!-- Dealer -->
              <div class="col-6 col-lg-4">
                <ng-select
                  placeholder="All dealers"
                  [items]="dealersList"
                  [(ngModel)]="exportFilters.dealer"
                  bindValue="id"
                  bindLabel="shop_name"
                  [clearable]="true"
                  [searchable]="true" />
              </div>

              <div class="col-12 col-lg-2 pe-0">
                <div class="w-100">
                  <button
                    class="btn btn-soft-primary w-100"
                    (click)="onExportDealerVisits()"
                    [disabled]="isExportingVisits">
                    @if (isExportingVisits) {
                      <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      Exporting...
                    } @else {
                      <i class="bi bi-download"></i>
                      Export Visits
                    }
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- Export Employee Visits Summary -->
          <div class="card bg-light p-3 mb-4">
            <div class="d-flex align-items-center gap-2 mb-2">
              <span class="fw-semibold small">Export Employee Visits Summary</span>
            </div>

            <!-- Mode toggle -->
            <div class="d-flex gap-3 mb-3">
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  id="modeSingle"
                  [(ngModel)]="visitsSummaryMode"
                  value="single" />
                <label class="form-check-label small" for="modeSingle">Single Date</label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  id="modeRange"
                  style="accent-color: #4880ff"
                  [(ngModel)]="visitsSummaryMode"
                  value="range" />
                <label class="form-check-label small" for="modeRange">Date Range</label>
              </div>
            </div>

            <div class="row align-items-end g-2">
              @if (visitsSummaryMode === 'single') {
                <div class="col-6 col-lg-3 ps-0">
                  <label class="form-label small text-muted mb-1">Date</label>
                  <input type="date" class="form-control form-control-sm" [(ngModel)]="visitsSummaryFilters.date" />
                </div>
              } @else {
                <div class="col-6 col-lg-3 ps-0">
                  <label class="form-label small text-muted mb-1">From</label>
                  <input
                    type="date"
                    class="form-control form-control-sm"
                    [(ngModel)]="visitsSummaryFilters.from_date" />
                </div>
                <div class="col-6 col-lg-3">
                  <label class="form-label small text-muted mb-1">To</label>
                  <input type="date" class="form-control form-control-sm" [(ngModel)]="visitsSummaryFilters.to_date" />
                </div>
              }

              <div class="col-6 col-lg-3">
                <button
                  class="btn btn-soft-primary"
                  (click)="onExportVisitsSummary()"
                  [disabled]="
                    isExportingVisitsSummary ||
                    (visitsSummaryMode === 'single' && !visitsSummaryFilters.date) ||
                    (visitsSummaryMode === 'range' &&
                      (!visitsSummaryFilters.from_date || !visitsSummaryFilters.to_date))
                  ">
                  @if (isExportingVisitsSummary) {
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    Exporting...
                  } @else {
                    <i class="bi bi-download"></i>
                    Export Employee Wise Summary
                  }
                </button>
              </div>
            </div>
          </div>

          <!-- Employee Filters -->
          <div class="row mb-3">
            <div class="col-12 col-md-8 ps-0">
              <div class="input-group">
                <span class="input-group-text bg-white border-end-0">
                  <i class="bi bi-search text-muted"></i>
                </span>
                <input
                  type="text"
                  class="form-control border-start-0"
                  placeholder="Search employees..."
                  [(ngModel)]="searchTerm"
                  (keyup)="onSearchKeyUp()" />
              </div>
            </div>
            <div class="col-12 col-md-4 pe-0">
              <ng-select
                placeholder="All Designations"
                [items]="designations"
                [(ngModel)]="selectedDesignation"
                bindValue="id"
                bindLabel="title"
                [clearable]="true"
                [searchable]="false"
                (ngModelChange)="onDesignationChange()" />
            </div>
          </div>

          @if (isEmployeesDataLoading) {
            <app-loading-spinner></app-loading-spinner>
          } @else {
            @if ((employees || []).length === 0) {
              <div class="empty-state-container">
                <i class="bi bi-people"></i>
                <h5 class="text-dark fw-bold">No Employees Found</h5>
                <p class="text-muted mb-4">No employees found matching your search criteria.</p>
              </div>
            } @else {
              <div class="table-responsive">
                <table class="table table-hover align-middle mb-0">
                  <thead class="bg-light">
                    <tr>
                      <th class="ps-4 border-0 text-uppercase small fw-bold text-muted py-3">Team Member</th>
                      <th class="border-0 text-uppercase small fw-bold text-muted py-3">Designation</th>
                      <th class="border-0 text-uppercase small fw-bold text-muted py-3">Joined On</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (emp of employees; track emp.id) {
                      <tr
                        class="cursor-pointer transition-all border-bottom"
                        [routerLink]="['/party-visits/employee', emp.id]">
                        <td class="ps-4 py-3">
                          <div class="d-flex align-items-center">
                            <div class="position-relative">
                              <img
                                [src]="
                                  emp.user.profile_picture ||
                                  getDefaultProfilePicUrl(emp.user.first_name, emp.user.last_name)
                                "
                                alt="{{ emp.user.first_name }} {{ emp.user.last_name }}"
                                class="rounded-circle border border-2 border-white shadow-sm bg-light"
                                width="42"
                                height="42"
                                (error)="handleImageError($event)" />
                            </div>
                            <div class="ms-3">
                              <div class="fw-bold text-dark">
                                {{ emp.user.first_name + ' ' + emp.user.last_name }}
                              </div>
                              <div class="small text-muted">{{ emp.user.email }}</div>
                            </div>
                          </div>
                        </td>
                        <td class="py-3">
                          <div class="d-flex flex-column">
                            <span class="fw-semibold text-dark">
                              {{ emp.designation.title }}
                            </span>
                          </div>
                        </td>
                        <td class="py-3">
                          <span class="text-muted small">
                            <i class="bi bi-calendar3 me-1"></i>
                            {{ emp.date_of_joining | date }}
                          </span>
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>

              <div class="mt-4">
                <app-pagination
                  [currentPage]="currentPage"
                  [totalCount]="totalCount"
                  [pageSize]="10"
                  [hasNextPage]="hasNextPage"
                  [hasPreviousPage]="hasPreviousPage"
                  (pageChange)="onPageChange($event)"></app-pagination>
              </div>
            }
          }
        </div>
      </div>
    </div>
  </div>
</div>
